import {Button, Card, Space, Menu, Dropdown, Tooltip} from "antd";
import {useTranslation} from "react-i18next";
import StudyFilter from "../../app/study/study-grid/StudyFilter";
import StudyGrid from "../../app/study/study-grid/StudyGrid";
import {DataGridProvider} from "../../core/components/data-grid/DataGridContext";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import {DATE_OPTIONS, getDateFromNow} from "../../core/utils/date-utils";
import {useEffect} from "react";
import AppConfig from "../../core/service/AppConfig";
import StudyQuickFilterBar from "../../app/study/study-grid/StudyQuickFilterBar";

export default function StudyGridPage()
{
    const {t} = useTranslation();

    useEffect(() => {
        document.title = `${t('Studies')} | ${AppConfig.getRisTitle()}`
    }, []);

    return (
        <>
            {/* Başlıktan seçilen sıralama tarayıcıda saklanır, sayfa yeniden açılınca korunur. */}
            <DataGridProvider sortStorageKey={'study'}>
                <LayoutWithSider
                    fullWidth={true}
                    sidebarTitle={t('Study Filter')}
                    rememberOpen={false}
                    sidebarComponent={(
                        <StudyFilter/>
                    )}
                >
                    {/* Hızlı filtreler grid kartının üstünde, her blok ayrı kart; uygulanan filtreyi sol panelle paylaşır.
                        Serbest arama da burada (her ekran boyutunda) — mobildeki ayrı GridSearchBar'ın yerini aldı. */}
                    <StudyQuickFilterBar />
                    <Card>
                        <StudyGrid />
                    </Card>
                </LayoutWithSider>
            </DataGridProvider>
        </>
    )
}
